import React from "react";
import { ErrorPageWrapper } from "./ErrorPageWrapper";
import { ErrorDesktopOffIcon } from "../Icons/ErrorDesktopOffIcon";
import { useErrorIconSize } from "../Icons/ErrorIconSize";

export const UnsupportedPlatformPage = (): JSX.Element => {
    const iconSize = useErrorIconSize();
    
    return (<ErrorPageWrapper
        icon={<ErrorDesktopOffIcon size={iconSize}/>}
        content={<label>Dein <b>Betriebssystem</b> wird leider nicht unterstützt.</label>}
    />);
}